<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="152.16" height="78.504" viewBox="0 0 152.16 78.504">
		<g id="Group_40574" data-name="Group 40574" transform="translate(-10380.01 -16832.851)">
			<g id="Group_40575" data-name="Group 40575" transform="translate(10380 16832.859)">
				<path
					id="Path_29085"
					data-name="Path 29085"
					d="M108.828,21.414l.511-.094L55.586,56.8l-1.8-13.7Z"
					transform="translate(11.173 -1.774)"
					fill="#cee5fc"
				/>
				<path
					id="Path_29078"
					data-name="Path 29078"
					d="M51.973,37.016,40.958,28.053,107.6,14.821Z"
					transform="translate(12.988 4.7)"
					fill="#e3f0fc"
				/>
				<path
					id="Path_29079"
					data-name="Path 29079"
					d="M50.647,43.585,54.784,36.3l3.045,2.977Z"
					transform="translate(16.06 11.511)"
					fill="#c9dbed"
				/>
				<line id="Line_1135" data-name="Line 1135" x2="1.746" y2="13.379" transform="translate(64.961 41.716)" fill="none" />
				<g id="Group_40574-2" data-name="Group 40574" transform="translate(0 0)">
					<g id="Group_40577" data-name="Group 40577">
						<path
							id="Path_29080"
							data-name="Path 29080"
							d="M48.621,43.158c-.408.3-.876.639-1.4,1"
							transform="translate(14.974 13.686)"
							fill="none"
							stroke="#cee5fb"
							stroke-linejoin="round"
							stroke-width="1.2"
						/>
						<path
							id="Path_29081"
							data-name="Path 29081"
							d="M58.462,48.864c-5.383,3.182-13.841,6.773-23.786,5.631C33.3,54.336,18.106,52.43,15.661,44.256c-.141-.474-1.326-4.436.877-7.314a7.684,7.684,0,0,1,4.973-2.632c2.663-.46,6.341.091,8.191,2.339,3.025,3.677-.116,10.338-1.17,12.578C23.362,60.195,10.018,64.645,2.651,66.372"
							transform="translate(0.841 10.833)"
							fill="none"
							stroke="#cee5fb"
							stroke-linejoin="round"
							stroke-width="1.2"
							stroke-dasharray="5.983 5.983"
						/>
						<path
							id="Path_29082"
							data-name="Path 29082"
							d="M1.78,58.9c-.643.134-1.212.242-1.691.329"
							transform="translate(0.028 18.678)"
							fill="none"
							stroke="#cee5fb"
							stroke-linejoin="round"
							stroke-width="1.2"
						/>
						<path
							id="Path_29083"
							data-name="Path 29083"
							d="M76.389,1.032a6.141,6.141,0,0,1,3.719.987A10.23,10.23,0,0,1,83.819.5"
							transform="translate(26.287 0.581)"
							fill="none"
							stroke="#cee5fb"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
						/>
						<path
							id="Path_29084"
							data-name="Path 29084"
							d="M105.933,12.921a9.564,9.564,0,0,1,5.787,1.548c.651-.842,4.786-2.284,5.77-2.375"
							transform="translate(33.592 3.836)"
							fill="none"
							stroke="#cee5fb"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
						/>
					</g>
				</g>
				<path
					id="Path_29086"
					data-name="Path 29086"
					d="M103.529,14.821,67.855,56.869,53.788,43.106Z"
					transform="translate(17.057 4.703)"
					fill="#e3f0fc"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'EmptyStateSvg',
};
</script>
